//React
import React from "react";

//Redux
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
//Material-ui
import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
//Icon
import ArrowBackIosIcon from '@material-ui/icons/ArrowBackIos';



const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class Comp extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      text: '',
  	}
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.open === false && this.props.open === true) {
      this.setState({text: this.props.memo.text})
    }
  }

	render() {
		return (
      <Dialog
        fullScreen
        open={this.props.open}
        onClose={ () => this.props.close() }
        TransitionComponent={Transition}
        style={{maxWidth:'600px', margin:'auto'}}
        scroll='paper'
      >
        <div style={{width:'100%'}} className='shadow'>
          <div
            style={{
              display:'flex',
              flexDirection:'row',
              alignItems:'center',
              justifyContent: 'space-between',
            }}
          >
            <div>
              <IconButton
                onClick={ () => this.props.close() }
                >
                <ArrowBackIosIcon />
              </IconButton>
              メモ条件
            </div>
            <div style={{margin:'5px'}}>
              <Button
                variant="outlined"
                color='primary'
                onClick={ () => this.props.submit('') }
                size='small'
              >
                条件をリセット
              </Button>
            </div>
          </div>
        </div>

        <DialogContent style={{padding:'10px'}}>
          <div>
            <div style={{padding:'3%'}}>
              <h3>
                検索ワード
              </h3>
              <div style={{textAlign:'center'}}>
                <input
                  value={this.state.text}
                  onChange={ (e) => this.setState({text: e.target.value}) }
                  style={{fontSize:'1.2em',width:'80%'}}
                  className={ "input_blue round6" }
                />
              </div>
            </div>


          </div>

          <div style={{padding:'10px'}}>

            <Button
              variant="contained"
              color='primary'
              onClick={ () => this.props.submit(this.state.text.replace(/　/g, " ")) }
              style={{width: '100%', fontSize:'1.2em'}}
            >
              検索する
            </Button>
          </div>
        </DialogContent>

      </Dialog>
		)
	}
}

const mapStateToProps = (state) => {
	return {
    memo: state.memo,
	}
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators({
	}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(Comp);
